<template>
    <v-dialog v-model="dialog" persistent max-width="600px" @keydown.esc="annulla()"
        style="margin-left: 4px !important; margin-right: 4px !important;">
        <v-card><!--  :fullscreen="$vuetify.breakpoint.xs" -->
            <v-card-title>
                <span v-if="evento.prog">Dettaglio</span>
                <span v-else>Nuovo</span>

                <v-text-field type="date" v-model="eventoLocal.data" class="mt-0 ml-2 pt-0 date-compatta" dense
                    style="font-weight: bold; font-size:1em" hide-details @input="verificaDataMinima()"
                    :disabled="(!isProprietario && !amministratore) || eventoBloccato" :key="aggiornaData" />
                <v-spacer />
                <v-btn icon @click="annulla()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <!-- Avviso evento confermato/rifiutato: solo per il proprietario (non admin) -->
                <v-alert v-if="!amministratore && eventoBloccato && isProprietario"
                    :type="evento.idStato == 2 ? 'success' : 'warning'" dense text class="mb-4">
                    Questo evento è stato <strong>{{ evento.idStato == 2 || evento.idStato == 5 ? 'confermato' :
                        'rifiutato' }}</strong>.
                    Per richiedere modifiche contattare l'ufficio.
                </v-alert>

                <!-- Dettagli completi: solo per il creatore o l'admin -->
                <template v-if="isProprietario || amministratore">
                    <v-autocomplete v-if="amministratore" label="Utente" dense v-model="utenteSel" :items="dipendenti"
                        item-text="displayName" return-object />

                    <v-select v-model="eventoLocal.idTipologia" :items="elencoTipi" item-text="descrizione"
                        item-value="id" label="Tipo" outlined dense class="mb-4"
                        :disabled="(eventoBloccato && !amministratore)">
                        <template v-slot:selection="{ item }">
                            <v-icon small :color="item.colore || '#9E9E9E'" class="mr-2">circle</v-icon>
                            <span>{{ item.descrizione }}</span>
                        </template>
                        <template v-slot:item="{ item }">
                            <v-list-item-icon class="mr-2">
                                <v-icon small :color="item.colore || '#9E9E9E'">circle</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.descrizione }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-select>

                    <v-select v-model="fasciaSelezionata" :items="opzioniFascia" label="Durata / Fascia" outlined dense
                        @change="calcolaOrario" :disabled="(eventoBloccato && !amministratore)" />

                    <v-row>
                        <v-col cols="6">
                            <v-text-field v-model="eventoLocal.oraInizio" label="Dalle ore" type="time" outlined dense
                                @input="getSovrapposizione(); aggiornaDurataDaOrari();"
                                :disabled="(eventoBloccato && !amministratore)"
                                style="font-weight:bold; font-size:1.2em;" />
                        </v-col>
                        <v-col cols="6">
                            <v-text-field v-model="eventoLocal.oraFine" label="Alle ore" type="time" outlined dense
                                @input="getSovrapposizione(); aggiornaDurataDaOrari();"
                                :disabled="(eventoBloccato && !amministratore)"
                                style="font-weight:bold; font-size:1.2em;" />
                        </v-col>
                    </v-row>

                    <v-alert dense text type="info" class="caption mt-n2" :key="aggiornaLabel">
                        Durata totale calcolata: <strong>{{ eventoLocal.ore }}h {{ eventoLocal.minuti }}m</strong>
                    </v-alert>

                    <v-textarea v-model="eventoLocal.descrizione" label="Note" outlined rows="3" dense hide-details
                        class="mt-2" :disabled="(eventoBloccato && !amministratore)" />

                    <!-- Motivo rifiuto (visibile se rifiutato) -->
                    <v-textarea v-if="eventoRifiutato" v-model="motivoRifiuto" label="Motivo rifiuto" outlined rows="2"
                        dense hide-details class="mt-4" :readonly="!amministratore" />

                    <!-- Info creazione/conferma/rifiuto -->
                    <v-divider v-if="evento.prog" class="mt-4 mb-3" />
                    <div v-if="evento.prog" class="caption grey--text">
                        <div v-if="evento.dataCreazione">
                            <v-icon x-small class="mr-1">event</v-icon>
                            Creato il: {{ formatData(evento.dataCreazione) }}
                        </div>
                        <div v-if="evento.dataPreConferma" class="mt-1">
                            <v-icon x-small color="success" class="mr-1">check_circle</v-icon>
                            Pre confermato il: {{ formatData(evento.dataPreConferma) }}
                        </div>
                        <div v-if="evento.dataConferma" class="mt-1">
                            <v-icon x-small color="success" class="mr-1">check_circle</v-icon>
                            Confermato il: {{ formatData(evento.dataConferma) }}
                        </div>
                        <div v-if="evento.dataRifiuto" class="mt-1">
                            <v-icon x-small color="error" class="mr-1">cancel</v-icon>
                            Rifiutato il: {{ formatData(evento.dataRifiuto) }}: {{ evento.statoRifiuto }}
                        </div>
                        <div v-if="evento.dataElimina" class="mt-1">
                            <v-icon x-small color="error" class="mr-1">delete</v-icon>
                            Eliminato il: {{ formatData(evento.dataElimina) }}
                        </div>
                    </div>
                </template>

                <!-- Vista ridotta per utenti non proprietari -->
                <template v-else>
                    <div class="subtitle-1 font-weight-medium mb-2" v-if="evento.idStato == 2">
                        {{ amministratore ? evento.utente + ' - ' : '' }}{{ evento.tipologia }}
                    </div>
                    <div class="subtitle-1 font-weight-medium mb-2" v-else>
                        Richiesta di {{ evento.tipologia }}
                    </div>
                    <div class="body-2 grey--text">
                        <v-row class="ma-0 pa-0">
                            <v-icon small class="mr-1">schedule</v-icon>
                            {{ formatOrario(evento.oraInizio) }} – {{ formatOrario(evento.oraFine) }}
                            <v-spacer />
                            <v-chip :color="evento.coloreGruppo">{{ evento.descGruppo }}</v-chip>
                        </v-row>
                    </div>
                </template>
            </v-card-text>

            <v-card-actions class="pl-1 pr-1">
                <!-- Elimina: disponibile per tutti (proprietario o admin) se l'evento esiste -->
                <v-btn color="error" @click="elimina()"
                    v-if="evento.prog && (amministratore || quasiAmministratore) && !eventoEliminato" small>
                    Elimina
                </v-btn>
                <v-spacer />
                <!-- Azioni admin: conferma / rifiuta / annulla stato -->
                <div v-if="amministratore && evento.prog && !eventoEliminato"
                    style="display: flex; flex-wrap: wrap; gap: 8px;" class="ml-1 mr-1">
                    <v-btn v-if="!eventoBloccato" color="error" outlined @click="rifiuta()" width="100%">Rifiuta</v-btn>
                    <v-btn
                        v-if="eventoBloccato && ((quasiAmministratore && evento.idStato == 5) || (amministratore && !quasiAmministratore))"
                        color="warning" outlined @click="annullaStato()" width="100%">
                        Annulla {{ (evento.idStato == 2 || evento.idStato == 5) ? (evento.idStato == 5 ? 'Pre conf.'
                            : 'conferma') : 'rifiuto' }}
                    </v-btn>
                    <v-btn
                        v-if="!eventoBloccato || (eventoBloccato && evento.idStato == 5 && !quasiAmministratore && amministratore)"
                        color="success" @click="conferma()" width="100%">Conferma</v-btn>
                </div>

                <!-- Salva: solo se non bloccato e si è il proprietario (o admin) -->
                <v-btn color="primary" @click="salva()"
                    v-if="((isProprietario && !eventoBloccato) || amministratore) && !eventoEliminato">
                    Salva
                </v-btn>
            </v-card-actions>
        </v-card>

        <!-- Dialog motivo rifiuto -->
        <v-dialog v-model="dialogRifiuto" max-width="400px" persistent>
            <v-card>
                <v-card-title>Motivo del rifiuto</v-card-title>
                <v-card-text>
                    <v-textarea v-model="motivoRifiuto" label="Motivo" outlined rows="3" dense autofocus />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogRifiuto = false">Annulla</v-btn>
                    <v-btn color="error" @click="confermaRifiuto()">Rifiuta</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import {
    salva_evento, elimina_evento,
    conferma_evento, rifiuta_evento, annulla_stato_evento,
    verifica_sovrapposizione,
    get_utenti
} from '@/api/api.dati';

export default {
    props: {
        dialog: { type: Boolean, default: false },
        elencoTipi: { type: Array, default: () => [] },
        elencoStati: { type: Array, default: () => [] },
        evento: { type: Object, default: () => null },
    },

    data() {
        return {
            fasciaSelezionata: 'tutto-giorno',
            opzioniFascia: [
                { text: 'Tutto il giorno (8h)', value: 'tutto-giorno' },
                { text: 'Mattino (4h)', value: 'mattino' },
                { text: 'Pomeriggio (4h)', value: 'pomeriggio' },
                { text: 'Personalizzato', value: 'custom' },
            ],
            eventoLocal: {},
            aggiornaLabel: 1,
            dialogRifiuto: false,
            motivoRifiuto: '',

            dipendenti: [],
            utenteSel: {},

            sovrapposizione: false,
            aggiornaData: 1,
        }
    },

    watch: {
        dialog(val) {
            if (val) this.init();
        },

        "eventoLocal.data": function () {
            this.getSovrapposizione();
        },
        "eventoLocal.oraInizio": function () {
            this.getSovrapposizione();
        },
        "eventoLocal.oraFine": function () {
            this.getSovrapposizione();
        }
    },

    computed: {
        amministratore() {
            return this.$store.getters["user/getAmministratore"];
        },

        quasiAmministratore() {
            return this.$store.getters["user/getQuasiAmministratore"];
        },

        userId() {
            return this.$store.getters["user/getUserId"];
        },

        isProprietario() {
            return !this.evento.prog || this.evento.idUtente == this.userId;
        },

        eventoBloccato() {
            return this.evento.idStato == 2 || this.evento.idStato == 3 || this.evento.idStato == 5;
        },

        eventoEliminato() {
            return this.evento.idStato == 4;
        },

        eventoRifiutato() {
            return this.evento.idStato == 3;
        },
    },

    methods: {
        init() {
            Object.assign(this.eventoLocal, this.evento);

            if (this.eventoLocal.data && this.eventoLocal.data.length > 10)
                this.eventoLocal.data = this.eventoLocal.data.substring(0, 10);
            this.motivoRifiuto = this.evento.statoRifiuto || '';

            this.fasciaSelezionata = this.determinaFascia(this.evento);
            this.calcolaOrario();

            if (this.amministratore) this.caricaDipendenti();

            this.getSovrapposizione();
        },

        async caricaDipendenti() {
            let res = await get_utenti();
            this.dipendenti = res.data;

            if (this.eventoLocal.idUtente)
                this.utenteSel = this.dipendenti.find(u => u.userId == this.eventoLocal.idUtente);
        },

        //#region Calcoli
        calcolaOrario() {
            switch (this.fasciaSelezionata) {
                case 'tutto-giorno':
                    this.eventoLocal.ore = 8;
                    this.eventoLocal.minuti = 0;
                    this.eventoLocal.oraInizio = "08:00";
                    this.eventoLocal.oraFine = "18:00";
                    break;
                case 'mattino':
                    this.eventoLocal.ore = 4;
                    this.eventoLocal.minuti = 0;
                    this.eventoLocal.oraInizio = "08:00";
                    this.eventoLocal.oraFine = "12:00";
                    break;
                case 'pomeriggio':
                    this.eventoLocal.ore = 4;
                    this.eventoLocal.minuti = 0;
                    this.eventoLocal.oraInizio = "14:00";
                    this.eventoLocal.oraFine = "18:00";
                    break;
                case 'custom':
                    break;
            }
        },

        aggiornaDurataDaOrari() {
            if (!this.eventoLocal.oraInizio || !this.eventoLocal.oraFine) return;

            const [hInizio, mInizio] = this.eventoLocal.oraInizio.split(':').map(Number);
            const [hFine, mFine] = this.eventoLocal.oraFine.split(':').map(Number);

            let diff = (hFine * 60 + mFine) - (hInizio * 60 + mInizio);
            if (diff < 0) diff = 0;

            this.eventoLocal.ore = Math.floor(diff / 60);
            this.eventoLocal.minuti = diff % 60;
            this.aggiornaLabel += 1;
        },

        determinaFascia(evento) {
            if (!evento.prog) return 'tutto-giorno'; // nuovo evento: default

            const oraInizio = (evento.oraInizio || '').substring(0, 5);
            const oraFine = (evento.oraFine || '').substring(0, 5);
            const ore = evento.ore;
            const minuti = evento.minuti;

            if (ore === 8 && minuti === 0 && oraInizio === '08:00' && oraFine === '18:00')
                return 'tutto-giorno';
            if (ore === 4 && minuti === 0 && oraInizio === '08:00' && oraFine === '12:00')
                return 'mattino';
            if (ore === 4 && minuti === 0 && oraInizio === '14:00' && oraFine === '18:00')
                return 'pomeriggio';

            return 'custom';
        },

        async getSovrapposizione() {
            let res = await verifica_sovrapposizione(this.eventoLocal);
            this.sovrapposizione = res.data;
        },

        verificaDataMinima() {
            const today = new Date();
            const todayPlus7 = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
            if (new Date(this.eventoLocal.data) < todayPlus7 && !this.amministratore) {
                this.$toast.alert("Come da regolamento i permessi dovranno essere richiesti 7 giorni prima della data di godimento. Per le urgenze contattare Massimo");
                this.eventoLocal.data = todayPlus7.toLocaleDateString('sv-SE');
                this.aggiornaData += 1;
                return;
            }
            this.getSovrapposizione();
        },
        //#endregion

        async salva() {
            // Controlla sovrapposizioni prima di salvare
            if (this.sovrapposizione === true) {
                let confirm = await this.$confirm.open(
                    "Sovrapposizione orari",
                    "Esistono già altri eventi in questo orario. Salvare comunque?"
                );
                if (!confirm) return;
            }

            if (this.amministratore && (!this.utenteSel || !this.utenteSel.userId)) {
                this.$toast.alert("Selezionare un utente");
                return;
            }

            if (this.amministratore && this.utenteSel)
                this.eventoLocal.idUtente = this.utenteSel.userId;

            if (!this.eventoLocal.idTipologia) {
                this.$toast.alert("Tipologia non valida");
                return;
            }
            if (this.sovrapposizione && !this.eventoLocal.descrizione) {
                this.$toast.alert("Esistono già altri eventi in questo orario. Inserire una nota di dettaglio.");
                return;
            }
            let res = await salva_evento(this.eventoLocal);
            if (res.data == "OK")
                this.chiudiDialog(true);
            else
                this.$toast.alert(res.data);
        },

        async elimina() {
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare l'evento selezionato?"
            );
            if (!confirm) return;
            if (this.amministratore && this.utenteSel)
                this.eventoLocal.idUtente = this.utenteSel.userId;
            let res = await elimina_evento(this.eventoLocal);
            if (res.data == "OK")
                this.chiudiDialog(true);
            else
                this.$toast.alert(res.data);
        },

        async conferma() {
            let res = await conferma_evento(this.eventoLocal);
            if (res.data == "OK") {
                this.$toast.info("Evento confermato");
                this.chiudiDialog(true);
            } else {
                this.$toast.alert(res.data);
            }
        },

        rifiuta() {
            this.motivoRifiuto = '';
            this.dialogRifiuto = true;
        },

        async confermaRifiuto() {
            this.dialogRifiuto = false;
            let res = await rifiuta_evento({ ...this.eventoLocal, statoRifiuto: this.motivoRifiuto });
            if (res.data == "OK") {
                this.$toast.info("Evento rifiutato");
                this.chiudiDialog(true);
            } else {
                this.$toast.alert(res.data);
            }
        },

        async annullaStato() {
            let confirm = await this.$confirm.open(
                "Annulla stato",
                `Annullare lo stato "${(this.evento.idStato == 2 || this.evento.idStato == 5) ? 'confermato' : 'rifiutato'}" e riportare l'evento in attesa?`
            );
            if (!confirm) return;

            let res = await annulla_stato_evento(this.eventoLocal);
            if (res.data == "OK") {
                this.$toast.info("Stato annullato, evento riportato in attesa");
                this.chiudiDialog(true);
            } else {
                this.$toast.alert(res.data);
            }
        },

        chiudiDialog(refresh) {
            this.eventoLocal = {};
            this.motivoRifiuto = '';
            this.$emit('chiudi', refresh);
        },

        annulla() {
            this.chiudiDialog(false);
        },

        formatData(val) {
            if (!val) return '';
            return new Date(val).toLocaleString('it-IT', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit'
            });
        },

        formatOrario(val) {
            if (!val) return '';
            return val.substring(0, 5);
        },
    },
}
</script>

<style scoped>
::v-deep .date-compatta input[type="date"] {
    width: 120px !important;
    min-width: 0 !important;
    padding-right: 0 !important;
}

::v-deep .date-compatta input[type="date"]::-webkit-calendar-picker-indicator {
    margin: 0 !important;
    padding: 0 !important;
    margin-left: -4px !important;
}
</style>